import type { StockConfiguration } from '../../../domain/configurations';

/**
 * The ItemConfigurationRendererEvent is dispatched when the user has picked one of the configurations a stock position's item comes in.
 *
 * Raised by the row above the answers list rather than by its dropdown, which says nothing outside the row: a listener is told which configuration was picked, for which stock configuration, and never has to know the row is made of a dropdown.
 */
export default class ItemConfigurationRendererEvent extends Event {
	/**
	 * The static ITEM_CONFIGURATION_CHANGED type is dispatched when the user has picked a configuration of the item.
	 *
	 * Only for a pick the user made, and only when it is not the one the configuration already names: the row picks that one itself each time it is shown a configuration, and says nothing about it.
	 *
	 * Example: addEventListener(ItemConfigurationRendererEvent.ITEM_CONFIGURATION_CHANGED, (event: ItemConfigurationRendererEvent) => {});
	 */
	public static ITEM_CONFIGURATION_CHANGED = 'ItemConfigurationRendererEvent.itemConfigurationChanged';

	/** The stock configuration the pick was made on. Still naming the configuration it named before: asking for one in the configuration picked is for whoever catches this. */
	public get configuration(): StockConfiguration {
		return this.#configuration;
	}

	/** The configuration picked, by its code — `K001`. */
	public get itemConfiguration(): string {
		return this.#itemConfiguration;
	}

	#configuration: StockConfiguration;

	#itemConfiguration: string;

	public constructor(configuration: StockConfiguration, itemConfiguration: string) {
		super(ItemConfigurationRendererEvent.ITEM_CONFIGURATION_CHANGED, { bubbles: true });
		this.#configuration = configuration;
		this.#itemConfiguration = itemConfiguration;
	}
}
